import PropTypes from 'prop-types';

/**
 * Playground two-column shell (CT-5190).
 *
 * Configuration left, live preview pinned right. Plain Tailwind grid rather than
 * `ResizableSidePanel`: the columns are not resizable in V1, and shipping a
 * resize affordance that does nothing is worse than not shipping one.
 *
 * The left column scrolls with the page while the right one is `sticky`, so the
 * preview stays in view through a long Data step.
 */
function WidgetPlaygroundLayout({ configuration = null, preview = null }) {
  return (
    <div className="flex min-w-0 flex-col gap-6 lg:flex-row lg:items-start">
      <div className="flex min-w-0 flex-1 flex-col gap-4">{configuration}</div>
      {/* 44% of the row, as in the design source of truth. The old fixed
          380/420px was narrower than the preview's own `large` width, so the
          card hit the column edge and `medium` and `large` looked the same. */}
      <div className="w-full shrink-0 lg:sticky lg:top-4 lg:w-[44%]">{preview}</div>
    </div>
  );
}

WidgetPlaygroundLayout.propTypes = {
  configuration: PropTypes.node,
  preview: PropTypes.node,
};

export default WidgetPlaygroundLayout;
